import {
  DEFAULT_ACCENT_COLOR,
  DEFAULT_CUSTOM_ACCENT_HEX,
  type AccentColor,
  isAccentColor,
} from './theme-accent.constants';
import { normalizeHexColor } from './theme-accent.utils';

export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export function readStoredTheme(storageKey: string, defaultTheme: ThemeMode): ThemeMode {
  const stored = localStorage.getItem(storageKey);
  return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : defaultTheme;
}

export function readStoredAccentColor(storageKey: string): AccentColor {
  const stored = localStorage.getItem(storageKey);
  return isAccentColor(stored) ? stored : DEFAULT_ACCENT_COLOR;
}

export function readStoredCustomAccentColor(storageKey: string): string {
  return normalizeHexColor(localStorage.getItem(storageKey) ?? '') ?? DEFAULT_CUSTOM_ACCENT_HEX;
}

export function resolveTheme(theme: ThemeMode): ResolvedTheme {
  if (theme !== 'system') return theme;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
